import Video from '../content-types/video';

function DotVideo({ node }) {
    const attrs = node?.attrs;

    if (!attrs?.data) {
        return null;
    }

    return (
        <div className="my-1">
            <Video {...attrs.data} />
        </div>
    );
}

export default DotVideo;
